import React from "react";

export const emailContext = React.createContext();
